/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentGoCampaign_Precincts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for GoCampaign Precinct API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Sunday, October 27, 2019 - 01:52:36 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      10/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const GoCampaign_Precincts = {
    all: (countryid, stateid, gc_countyid, precinctgroupid) => requests.get(`/GoCampaignPrecincts?countryid=${countryid}&stateid=${stateid}&gc_countyid=${gc_countyid}&precinctgroupid=${precinctgroupid}`),
    get: gocampaignprecinctid => requests.get(`/GoCampaignPrecinct/${gocampaignprecinctid}`),
    create: gocampaignprecinct => requests.post(`/GoCampaignPrecincts`, gocampaignprecinct),
    update: (gocampaignprecinctid, gocampaignprecinct) => requests.put(`/GoCampaignPrecinct/${gocampaignprecinctid}`, gocampaignprecinct),
    delete: gocampaignprecinctid => requests.del(`/GoCampaignPrecinct/${gocampaignprecinctid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentGoCampaign_Precincts.js